import { render } from "./ComMunication.vue?vue&type=template&id=7edd574f"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/ComMunication.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7edd574f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7edd574f', __exports__)) {
    api.reload('7edd574f', __exports__)
  }
  
  module.hot.accept("./ComMunication.vue?vue&type=template&id=7edd574f", () => {
    api.rerender('7edd574f', render)
  })

}


export default __exports__